import { render } from "./JadwalView.vue?vue&type=template&id=4ae7bba8"
import script from "./JadwalView.vue?vue&type=script&lang=js"
export * from "./JadwalView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__